import { useEffect, useState } from 'react';
import api from '../lib/api';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { PersonalDetails } from '../components/portal/PersonalDetails';
import { EntityDetails } from '../components/portal/EntityDetails';
import { ClientMfaCard } from '../components/portal/ClientMfaCard';

const STATUS = { applied: 'Updated', pending: 'Waiting for approval', awaiting_verification: 'Confirm your email', approved: 'Approved', rejected: 'Not approved' };
const show = (v) => (v && typeof v === 'object' ? JSON.stringify(v) : v ?? '—');

const ChangeHistory = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get('/api/portal/change-history').then(({ data }) => setRows(data)).catch(() => {}); }, []);
  return (
    <div className="rounded-xl border border-border divide-y divide-border bg-card" data-testid="change-history">
      {rows.length === 0 && <p className="p-6 text-sm text-muted-foreground">No changes yet.</p>}
      {rows.map((r) => (
        <div key={r.id} className="p-4 space-y-1" data-testid={`change-row-${r.id}`}>
          <div className="flex items-center gap-2 text-sm"><Badge variant="outline">{STATUS[r.status] || r.status}</Badge>
            <span className="text-muted-foreground">{new Date(r.created_at).toLocaleString('en-AU')}</span></div>
          {r.changes.map((c) => <p key={c.field} className="text-sm">{c.label}: <span className="text-muted-foreground">{show(c.old)}</span> → {show(c.new)}</p>)}
          {r.reason && <p className="text-xs text-destructive">Reason: {r.reason}</p>}
        </div>
      ))}
    </div>
  );
};

export default function MyDetails() {
  return (
    <div className="p-6 lg:p-10 space-y-8" data-testid="my-details-page">
      <div>
        <h1 className="text-4xl sm:text-5xl font-headings font-bold">My details</h1>
        <p className="text-sm text-muted-foreground mt-2">Details for the entity you're working with (top right).</p>
      </div>
      <Tabs defaultValue="personal">
        <TabsList>
          <TabsTrigger value="personal" data-testid="tab-my-personal">Personal</TabsTrigger>
          <TabsTrigger value="entity" data-testid="tab-my-entity">Entity details</TabsTrigger>
          <TabsTrigger value="history" data-testid="tab-my-history">Change history</TabsTrigger>
          <TabsTrigger value="security" data-testid="tab-my-security">Sign-in security</TabsTrigger>
        </TabsList>
        <TabsContent value="personal"><PersonalDetails /></TabsContent>
        <TabsContent value="entity"><EntityDetails /></TabsContent>
        <TabsContent value="history"><ChangeHistory /></TabsContent>
        <TabsContent value="security"><ClientMfaCard /></TabsContent>
      </Tabs>
    </div>
  );
}
